import React, { Component } from "react";
import styles from "./cmsUserCreateTool.module.scss";
import { Select, MenuItem, TextField } from "@mui/material";
import { states } from "../../../reducers/queriesStates";
import { withRoles } from "../../../shared/containers/containerRoles";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import Preloader from "../../../shared/items/static/preloader";
import configuration from "./../../../config.json";
import { withUsers } from "../../../shared/containers/containerUsers";

class CmsUserCreateTool extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      title: "",
      password: "",
      roleType: 0,
      error: null,
    };
  }

  componentDidUpdate(prevProps) {
    const { createUserDataState, errors } = this.props;

    if (createUserDataState === states.FAILURE && prevProps.createUserDataState === states.REQUEST) {
      this.setState({ error: errors });
    }

    if (createUserDataState === states.READY && prevProps.createUserDataState === states.REQUEST) {
      this.setState({
        email: "",
        title: "",
        password: "",
        roleType: 0,
        error: null,
      });
    }
  }

  changeEmail(e) {
    this.setState({ email: e.target.value, error: null });
  }

  changeTitle(e) {
    this.setState({ title: e.target.value, error: null });
  }

  changePassword(e) {
    this.setState({ password: e.target.value, error: null });
  }

  changeRoleType(e) {
    this.setState({ roleType: e.target.value, error: null });
  }

  buttonDisabled() {
    const { email, title, password, roleType } = this.state;

    if (configuration.isLocalApp) {
      return email.length === 0 || !email.includes("@") || title.length < 3 || password.length < 6 || roleType === 0;
    }

    return email.length === 0 || !email.includes("@") || roleType === 0;
  }

  handleClickButton() {
    const { email, roleType, title, password } = this.state;
    const { onCreateUser, onCreateUserLocalVersion, companyId } = this.props;

    if (configuration.isLocalApp && configuration.localAppConfig.userWithoutEmail) {
      onCreateUserLocalVersion({ email, roleType, companyId, title, password });
    } else {
      onCreateUser({ email, roleType, companyId });
    }
  }

  render() {
    const { email, title, password, error } = this.state;
    const { roles, createUserDataState } = this.props;

    return (
      <div className={styles.cmsUserCreateToolContainer}>
        <div className={styles.errorContainer}>{error}</div>

        <div className={styles.inputsContainer}>
          <div>
            <TextField
              size="small"
              label="Почта нового пользователя "
              inputProps={{ sx: { width: "300px" } }}
              variant="outlined"
              value={email}
              onChange={this.changeEmail.bind(this)}
            />
          </div>

          {configuration.isLocalApp && configuration.localAppConfig.userWithoutEmail ? (
            <div>
              <TextField
                size="small"
                label="ФИО"
                inputProps={{ sx: { width: "300px" } }}
                variant="outlined"
                value={title}
                onChange={this.changeTitle.bind(this)}
              />
            </div>
          ) : null}

          {configuration.isLocalApp && configuration.localAppConfig.userWithoutEmail ? (
            <div>
              <TextField
                size="small"
                label="Пароль"
                inputProps={{ sx: { width: "300px" } }}
                variant="outlined"
                value={password}
                onChange={this.changePassword.bind(this)}
              />
            </div>
          ) : null}

          <div>
            <Select style={{ minWidth: "200px" }} onChange={this.changeRoleType.bind(this)} size="small">
              {roles
                .sort((a, b) => {
                  return b.roleType - a.roleType;
                })
                .map((role) => {
                  return (
                    <MenuItem key={role.id} value={role.roleType}>
                      {role.title}
                    </MenuItem>
                  );
                })}
            </Select>
          </div>

          <div>
            {createUserDataState === states.REQUEST ? null : (
              <ButtonPrimary disabled={this.buttonDisabled()} handleClick={this.handleClickButton.bind(this)} title="Создать" />
            )}
          </div>

          {createUserDataState === states.REQUEST ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Preloader />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default withUsers(withRoles(React.memo(CmsUserCreateTool)));
